import { render, staticRenderFns } from "./IntegrationGallery.vue?vue&type=template&id=1ece0374&scoped=true"
import script from "./IntegrationGallery.vue?vue&type=script&lang=js"
export * from "./IntegrationGallery.vue?vue&type=script&lang=js"
import style0 from "./IntegrationGallery.vue?vue&type=style&index=0&id=1ece0374&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ece0374",
  null
  
)

export default component.exports